import script from "./MaterialAIs.vue?vue&type=script&setup=true&lang=ts"
export * from "./MaterialAIs.vue?vue&type=script&setup=true&lang=ts"

import "./MaterialAIs.vue?vue&type=style&index=0&id=3a1f2084&scoped=true&lang=less"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a1f2084"]])

export default __exports__